import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d382b11"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "profileUserModal",
  tabindex: "-1",
  "aria-labelledby": "profileUserModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = { class: "modal-content p-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_5 = { class: "content mx-auto" }
const _hoisted_6 = { class: "fs-7 mb-5 text-break break-spaces" }
const _hoisted_7 = { class: "user-info p-3 bg-gray position-relative d-flex justify-content-center align-items-center mx-auto mb-3 mb-lg-5" }
const _hoisted_8 = { class: "w-100 m-0 p-0 mt-3" }
const _hoisted_9 = { class: "d-flex flex-lg-row flex-column text-center text-lg-start" }
const _hoisted_10 = { class: "col-lg-3" }
const _hoisted_11 = { class: "col-lg-9 text-nowrap" }
const _hoisted_12 = { class: "tag text-white position-absolute d-flex justify-content-center align-items-center" }
const _hoisted_13 = { class: "mb-3 mb-lg-5" }
const _hoisted_14 = { class: "d-flex justify-content-center align-items-center" }

import { computed, watch, ref, watchEffect, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import TimeLine from '@/views/user/account/profile/setting/components/TimeLine.vue'
import UserAvatar from '@/views/user/account/profile/setting/components/EmployeeAvatar.vue'
import { ACCOUNT_STORE, COMMUNITY_STORE } from '@/store/constants'
import { ID } from '../languages/ID'
import { CommunityStateTypes } from '@/store/modules/community'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const profileDetail = computed(() => store.getters[ACCOUNT_STORE.GETTERS.PROFILE_DETAIL]?.profileDetail)
const me = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME])

const imageUrl = ref('')

watchEffect(() => {
  if (typeof me.value?.profile?.image_url !== 'string' && me.value?.profile?.image_url) {
    imageUrl.value = URL.createObjectURL(me.value?.profile?.image_url)
    return
  } else {
    imageUrl.value = me.value?.profile?.image_url
  }
})

watch(
  () => store.getters[ACCOUNT_STORE.GETTERS.PROFILE_DETAIL]?.profileDetail,
  () => {
    profileDetail.value = store.getters[ACCOUNT_STORE.GETTERS.PROFILE_DETAIL]?.profileDetail
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(UserAvatar, {
          imageUrl: imageUrl.value,
          userType: _unref(profileDetail)?.user_type,
          name: _unref(profileDetail).family_name + ' ' + _unref(profileDetail).given_name,
          nameKana: _unref(profileDetail).family_name_kana + ' ' + _unref(profileDetail).given_name_kana
        }, null, 8, ["imageUrl", "userType", "name", "nameKana"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(profileDetail)?.introduction), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(translate)('affiliation')), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(profileDetail)?.department_name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(translate)('SA20currentJob')), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(TimeLine)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": 'modal'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ]))
}
}

})